import { RawComment } from "./commentTypes";
export interface CommentNode extends RawComment {
  children: CommentNode[];
}

export function createCommentTree(
  root: RawComment,
  subs: RawComment[]
): CommentNode {
  const all = [root, ...subs];

  const pool = new Map<number, CommentNode>();
  all.forEach((c) => pool.set(c.id, { ...c, children: [] }));

  all.forEach((c) => {
    if (c.parentId == null) return;
    const parent = pool.get(c.parentId);
    parent?.children.push(pool.get(c.id)!);
  });

  const sort = (n: CommentNode) => {
    n.children.sort(
      (a, b) =>
        new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime()
    );
    n.children.forEach(sort);
  };
  const treeRoot = pool.get(root.id)!;
  sort(treeRoot);

  return treeRoot;
}
